export const GOLDEN_RATIO = 0.62;
export const ONE_MINUS_GOLDEN_RATIO = 0.38;
export const ONE_PLUS_GOLDEN_RATIO = 1.62;

export const THIRD_PERCENTAGE = '33%';
export const ONE_MINUS_THIRD_PERCENTAGE = '67%';
export const GOLDEN_RATIO_PERCENTAGE = '62%';
export const ONE_MINUS_GOLDEN_RATIO_PERCENTAGE = '38%';

export const ONE_MINUS_GOLDEN_RATIO_EM = '0.38em';
export const GOLDEN_RATIO_EM = '0.62em';
export const ALPHA_SHADOW_FOR_HEX = 20;

export const TOOLBAR_HEIGHT = 70;